
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12.139","height":"12.139"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"a","x1":".5","y1":"-.497","x2":".5","y2":"1.048","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#facc25"}}),_c('stop',{attrs:{"offset":".115","stop-color":"#fac324"}}),_c('stop',{attrs:{"offset":".505","stop-color":"#fc881b"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#fe4811"}})])]),_c('g',{attrs:{"data-name":"Group 22568"}},[_c('path',{attrs:{"data-name":"Path 546","d":"M6.069 0A6.069 6.069 0 110 6.069 6.069 6.069 0 016.069 0z","fill":"url(#a)"}}),_c('path',{attrs:{"data-name":"Polygon 1","d":"M6.069 2l1.2 2.686 2.8.37-2.058 2.03.53 2.914-2.472-1.431L3.597 10l.53-2.914-2.058-2.03 2.8-.37z","fill":"#fff"}})])])
          )
        }
      }
    